import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgIdCardLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M8 7c-1.22 0-2.295.393-3.03 1.313-.703.877-.97 2.08-.97 3.437s.267 2.56.97 3.437c.735.92 1.81 1.313 3.03 1.313s2.295-.392 3.03-1.313c.703-.877.97-2.08.97-3.437s-.267-2.56-.97-3.437C10.296 7.393 9.22 7 8 7m-2 4.75c0-1.143.233-1.815.53-2.188C6.796 9.232 7.22 9 8 9s1.205.232 1.47.562c.297.373.53 1.045.53 2.188s-.233 1.816-.53 2.188c-.265.33-.69.562-1.47.562s-1.205-.232-1.47-.562C6.234 13.565 6 12.893 6 11.75'
      clipRule='evenodd'
    />
    <path
      fill={props.color}
      d='M13.5 10.5a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1M14.5 12.5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2z'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M17.241 4H6.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C1 8.29 1 8.954 1 9.758v4.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 20 5.954 20 6.758 20h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V9.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 4 18.046 4 17.242 4M4.092 6.218c.156-.08.38-.145.819-.18C5.361 6 5.943 6 6.8 6h10.4c.857 0 1.439 0 1.889.038.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819C21 8.361 21 8.943 21 9.8v4.4c0 .857 0 1.439-.038 1.889-.035.438-.1.663-.18.819a2 2 0 0 1-.874.874c-.156.08-.38.145-.819.18-.45.037-1.032.038-1.889.038H6.8c-.857 0-1.439 0-1.889-.038-.438-.035-.663-.1-.819-.18a2 2 0 0 1-.874-.874c-.08-.156-.145-.38-.18-.819C3 15.639 3 15.057 3 14.2V9.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgIdCardLine)
export default ForwardRef
